import { defineStore } from 'pinia';
import IodineGrouperService, { InitData } from 'src/services/IodineGrouperService';
import { grouperService } from 'src/services/GrouperService';
import { computed, ref } from 'vue';
export const useGrouperStore = defineStore('grouperstore', () => {

  const aprExpanded = ref(false);
  const getAprExpanded = computed(() => aprExpanded.value);
  const diagnosisCodes = ref();
  const getDiagnosisCodes = computed(() => diagnosisCodes.value );
  const procedureCodes = ref();
  const getProcedureCodes = computed(() => procedureCodes.value );

  function expandCollapseApr() {
    aprExpanded.value = !aprExpanded.value;
  }

  function resetDRGData() {
    diagnosisCodes.value = undefined;
    procedureCodes.value = undefined;
  }

  const setVisitContext = IodineGrouperService.setVisitContext$.subscribe(
    async (initData: InitData) => {
      resetDRGData();

      grouperService.setAxiosConfig(initData.endpoint, initData.visitId, initData.facilityCode);

      const response = await grouperService.getGrouperData();

      diagnosisCodes.value = response.diagnosisCodes;
      procedureCodes.value = response.procedureCodes;
    }
  );

  return {
    aprExpanded,
    getAprExpanded,
    getDiagnosisCodes,
    getProcedureCodes,
    expandCollapseApr,
    setVisitContext
  }
})
